/* eslint-disable @next/next/no-img-element */
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import { useTranslation } from "next-i18next";
import { getDoctorsDetail } from "api/main";
import { CustomButton } from "components/General/CustomButton";
import { MemberPage } from "components/General/Pages/MemeberPage";
import NoItem from "components/General/NoItem";

type ITimes = {
  day: string;
  detail: { times: Array<{ time: string }>; place: string };
};

const DoctorDetais = () => {
  const router = useRouter();
  const { locale, query } = router;

  const items: Array<{ title: string; id: 0 | 1 }> = [
    { id: 0, title: "AboutDoctor" },
    { id: 1, title: "ClinicSchedule" },
  ];

  const headers = useMemo(() => ["روز", "ساعت", "بخش"], []);

  const [activeTab, setAvtiveTab] = useState<0 | 1>(0);

  const id = parseInt(query?.id as string);
  const { t } = useTranslation();

  const { data } = useQuery(["getDoctorsDetail", locale, id], () =>
    getDoctorsDetail({
      locale,
      id,
    })
  );

  return (
    <section className="container mb-120">
      <MemberPage isDoctor title={""} data={data?.data} />

      <div className="mt-64 flex border-b border-b-gray-D9D9D9 ">
        {items.map((el: { id: 0 | 1; title: string }) => {
          return (
            <p
              onClick={() => setAvtiveTab(el.id)}
              className={`${
                activeTab === el.id ? "border-b-3 border-b-primary-main" : ""
              } w-[260px] cursor-pointer pb-12 text-center text-20 text-secondary-main`}
              key={el.id}
            >
              {t(el.title)}
            </p>
          );
        })}
      </div>

      {activeTab === 0 ? (
        <div className="mt-32 rounded-10 border border-gray-D9D9D9 px-44 py-32">
          <p className="mb-22 text-18 font-bold text-secondary-main">{t("Education")} </p>
          <ul className=" list-disc gap-32 md:flex">
            {data?.data?.aboutDoctor?.education.map((el: { name: string }, i: number) => {
              return (
                <li className="text-16 text-gray-252525" key={i}>
                  {el.name}
                </li>
              );
            })}
          </ul>
          <p className="mt-42 mb-22 text-18  font-bold text-secondary-main">
            {t("ScientificAndWorkRecords")}
          </p>
          <ul className=" list-disc gap-32 md:flex">
            {data?.data?.aboutDoctor?.experience.map((el: { name: string }, i: number) => {
              return (
                <li className="text-16 text-gray-252525" key={i}>
                  {el.name}
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div>
          {data?.data?.clinicTimes?.length === 0 ? (
            <div key={-1} className="">
              <NoItem text={t("TheClinicScheduleIsEmpty")} />
            </div>
          ) : (
            <div className="mt-42 overflow-x-auto">
              <table
                id="data"
                className="w-full min-w-[800px] border-collapse overflow-y-hidden  rounded-5 md:min-w-0"
              >
                <thead className="">
                  <tr className="h-48 bg-gray-F7F7F7  ">
                    {headers.map((el, i) => {
                      return (
                        <th className={`px-12 text-16 font-normal text-[#0D4644] `} key={i}>
                          {t(el)}
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {data?.data?.clinicTimes?.map((item: ITimes, i: number) => (
                    <tr
                      key={i}
                      className="h-48 even:rounded-10 even:border even:border-gray-D9D9D9"
                    >
                      <td className={`m-auto px-12 text-center text-16 text-gray-4A4A4A`}>
                        {item?.day}
                      </td>
                      <td className={`m-auto px-12 text-center text-16 text-gray-4A4A4A`}>
                        {item?.detail.times.map(
                          (el, ii) =>
                            `${el.time} ${ii !== item?.detail.times.length - 1 ? "|" : ""} `
                        )}
                      </td>
                      <td className={`m-auto px-12 text-center text-16 text-gray-4A4A4A`}>
                        {item?.detail.place}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {!!data?.data?.appointmentLink && (
            <div className="mt-40 flex justify-end">
              <CustomButton href={data?.data?.appointmentLink} className="!rounded-[20px]">
                {t("ClinicAppointments")}
              </CustomButton>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export { DoctorDetais };
